import React from "react";
import PropTypes from "prop-types";

const TabNav = (props) => {
	return (<div className="c-anchor-nav c-anchor-nav--flexible">
		<div className="c-anchor-nav__wrapper">
			{props.children}
		</div>
	</div>);
};

TabNav.propTypes = {
	children: PropTypes.node
};

export default TabNav;
